import {
	backgroundColor,
	blackColors,
	whiteColor,
	hexToRgb,
	blackColor,
	support1Color,
	support2Color,
	primaryColor,
	successColor,
} from 'assets/jss/material-dashboard-pro-react';

const singleSlideStyle = () => ({
	buttonWrapper: {
		position: 'absolute',
		bottom: 0,
		width: '100%',
		textAlign: 'center',
		padding: '8px 0',
		'& > button': {
			margin: 0,
		},
	},
	grayBackground: {
		backgroundColor: backgroundColor[0],
	},
	headerWrapper: ({ headerHeight }) => ({
		backgroundColor: '#323232',
		height: headerHeight || 88,
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		flexDirection: 'column',
		textAlign: 'center',
	}),
	singleSlideWrapper: {
		transition: 'all .1s ease-in-out, opacity .2s ease-in-out',
		overflow: 'hidden',
		backgroundColor: whiteColor,
		position: 'relative',
		paddingBottom: 56,
		marginTop: 15,
		marginBottom: 15,
		borderRight: `0.5px solid ${blackColors[4]}`,
		borderLeft: `0.5px solid ${blackColors[4]}`,
		boxShadow: `0 2px 3px 0 rgba(${hexToRgb(blackColor)}, 0.5)`,
	},
	primaryCurrentPlanHeader: {
		background: `linear-gradient(#007ac1, #004c97)`,
	},
	secondaryCurrentPlanHeader: {
		background: `linear-gradient(#ff9f5c, #ff6900)`,
	},
	primarySelectedHeader: {
		background: `linear-gradient(${support1Color[1]}, ${primaryColor[0]})`,
	},
	secondarySelectedHeader: {
		background: `linear-gradient(#ff9f5c, #ff6900)`,
	},
	violetSelectedHeader: {
		background: `linear-gradient(${support2Color[1]}, ${support2Color[0]})`,
	},
	successSelectedHeader: {
		background: `linear-gradient(to top, ${successColor[0]}, ${successColor[1]})`,
	},
	currentPlanWrapper: {
		border: `1px solid ${whiteColor}`,
		borderRadius: 2,
		padding: '0 4px',
		marginBottom: 8,
		position: 'absolute',
		top: 10,
	},
	selectedSlideWrapper: ({ numberOfCells }) => ({
		marginTop: `${15 - numberOfCells}px`,
		marginBottom: `${15 - numberOfCells}px`,
		borderRadius: 8,
		boxShadow: `0 8px 12px 0 rgba(${hexToRgb(blackColor)}, 0.5)`,
		zIndex: 10,
		border: 'none!important',
	}),
	bodyWrapperSelected: {
		'& > div > div': {
			padding: '9px 5px',
		},
	},
	transparent: {
		opacity: 0,
	},
	firstSlide: {
		borderTopLeftRadius: 8,
		borderBottomLeftRadius: 8,
		borderLeft: 'none!important',
	},
	lastSlide: {
		borderTopRightRadius: 8,
		borderBottomRightRadius: 8,
		borderRight: 'none!important',
	},
	bodyWrapper: {
		backgroundColor: whiteColor,
		'& > div > div': {
			transition: 'all .1s ease-in-out, opacity .2s ease-in-out',
		},
	},
	unlimitedWrapper: {
		width: '100%',
		'& svg': {
			color: whiteColor,
		},
	},
	linearProgress: {
		maxWidth: 100,
		margin: '10px auto 0',
		height: 4,
		'& > div': {
			height: 4,
		},
	},
	progressBarWrapper: {
		width: '100%',
	},
});

export default singleSlideStyle;
